<template>
<div class="row">
  <div class="col-12 col-md-12">
    <h2 class="tit-sim">Flashcards Disponíveis</h2>
    <div class="meus-sim">
      <div class="table-responsive-xl">
        <table class="table">
          <tr>
            <th colspan="4"><i class="fas fa-list-ul"></i>{{ nomeCurso }}</th>
          </tr>
            <tr v-for="deck in decks">
              <td width="67px">
                <img :src="iconDeck" />
              </td>
              <td>
                <strong class="d-block mb-1">Deck do Jaleko</strong>
                {{ deck.nome }}
                <div class="like mt-2">
                  <div class="d-inline mr-2">
                    <i class="fas fa-thumbs-up"></i>
                    <span>{{ deck.likes }}</span>
                  </div>
                  <div class="d-inline">
                    <i class="fas fa-thumbs-down"></i>
                    <span>{{ deck.dislikes }}</span>
                  </div>
                </div>
              </td>
              <td class="text-right" width="20px">
                <div class="d-flex align-items-center justify-content-end">
                  <a @click="iniciarFlashcard(deck)" class="btn btn-comecar">Começar</a>
                </div>
              </td>
            </tr>
        </table>
      </div>
    </div>
    <span class="d-flex align-items-center justify-content-center"> Quer mais flashcards? Você pode montar o seu ou acessar os de outros estudantes.</span>
  </div>
</div>
</template>
<script>
export default {
  name: 'Flashcards',
  props: {
    curso: Object,
    decks: Array
  },
  data () {
    return {
    }
  },
  computed: {
    nomeCurso: function () {
      return this.curso.curso_estrutura.nome
    },
    configEmpresa: function () {
      return this.$store.getters.empresa
    },
    iconDeck: function () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/deck.svg`
    }
  },
  methods: {
    iniciarFlashcard: function (deck) {
      let url = `/flashcards/${deck.id}/iniciar?plataforma=b2b`
      window.open(url, '_blank')
    }
  }
}
</script>
